import http from '@/utils/http';


//获取benchmark列表
export function getMobileBenchmarkRankList(params:any): Promise<any> {
  return http(`/api/v1/intelligence_pc/mobileBenchmarkTable`, {
    method: 'post',
    rawData: true,
    data: {
      ...params,
      entity_type: 'mobile',
    },
  });
}


// 配置定义游戏层级列表
export function getMobileBenchmarkLevelList(params: any): Promise<any> {
  return http(`/api/v1/intelligence_pc/mobileBenchmarkLevelGameList`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

// 配置定义游戏列表
export function getMobileBenchmarkGameList(params: any): Promise<any> {
  return http(`/api/v1/intelligence_pc/mobileBenchmarkGameList`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

// 配置定义游戏列表
export function getBenchmarkCustomizeTopsGameList(params: any): Promise<any> {
  return http(`/api/v1/intelligence_pc/mobileBenchmarkCustomizeGameList`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}


// 配置定义游戏列表
export function addMobileBenchmarkCustomizeGame(params: {
  game_ids: string[];
  genre_type: string;
}): Promise<any> {
  return http(`/api/v1/intelligence_pc/addVidoeBenchmarkCustomizeGame`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

// 获取Figured数据
export function getMobileBenchmarkFigured(params: any): Promise<any> {
  return http(`/api/v1/intelligence_pc/mobileBenchmarkFigure`, {
    method: 'post',
    data: {
      ...params,
      entity_type: 'mobile',
      systems: ["Android","ios"],
      steam_source: ["ytg","twitch","facebook"],
      time_scale: ["365d", "lt", "30d"]
    },
  });
}

export function getMobileBenchmarkRegionFilter(params:any){
  return http('/api/v1/intelligence_pc/mobileBenchmarkRegionFilter', {
    method: 'post',
    data: {
      type: [
        {
          tabName: "mobile"
        }
      ],
      item: [
        {
          tabName: ""
        }
      ],
      ...params,
    },
  })
}



// // 下载
// export function downloadMobileBenchmarkMetricsExcel(params:any): Promise<ArrayBuffer> {
//   return http('/api/v1/intelligence_pc/topChartMobileBenchmarkMetricsExcel', {
//     method: 'post',
//     rawData: true,
//     data: {
//       ...params,
//     },
//     timeout: 2 * 60 * 1000,
//     httpResponses: true,
//     responseType: 'arraybuffer',
//   });
// }


// // 下载
// export function downloadVidoeBenchmarkMetricsExcel(params:any): Promise<ArrayBuffer> {
//   return http('/api/v1/intelligence_pc/topChartMobileBenchmarkMetricsExcel', {
//     method: 'post',
//     rawData: true,
//     data: {
//       ...params,
//     },
//     timeout: 2 * 60 * 1000,
//     httpResponses: true,
//     responseType: 'arraybuffer',
//   });
// }



